export function getPath(state) {
  var fullPath = "/activities";

  if (state.activeView) {
    fullPath += "/" + state.activeView;
  } else {
    fullPath += "/" + VIEWS.EXERCISE_VIEW;
  }
  return fullPath;
}

export function getRouteState(params) {
  var state = {};

  state.activeView = params.active_view;
  state.detailsView = params.details_view;
  state.textID = params.text_id;

  return state;
}

export const VIEWS = {
  EXERCISE_VIEW: "exercises",
  TEACHER_PICKS_VIEW: "teacher-picks"
}


export var PATH = "/activities/:active_view";


// WEBPACK FOOTER //
// ./modules/lib/routing/ActivitiesPageRouting.js